<template>
  <div class="flex flex-col items-center justify-center max-auto max-w-lg md:px-0 mx-auto p-10 px-4 w-full" data-testid="order-success-page">
    <h2 class="text-lg mb-4">{{  $t('You order is under validation, please wait....') }}</h2>
    <SfProgressCircular size="xl" />
  </div>
</template>

<script setup lang="ts">
import { SfProgressCircular } from '@storefront-ui/vue'
import { useSdk } from '~/sdk';

const route = useRoute();

onMounted(async () => {
  const data = await useSdk().commerce.orderValidate({
    ...route.query as unknown as Record<string, string>,
  });

  if (data && data.success) {
    location.href = data.redirectUrl as unknown as string;
  }

  if (data && !data.success) {
    location.href = data.redirectUrl as unknown as string;
  }
})

</script>
